(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-slider"] && !Shopify.designMode) return;
  try {
    
function whenSplideReady(cb) {
  if (window.Splide) return cb();
  var waited = 0;
  var iv = setInterval(function () {
    if (window.Splide) {
      clearInterval(iv);
      cb();
    } else {
      waited += 50;
      if (waited >= 5000) clearInterval(iv);
    }
  }, 50);
}

function initMulticolumnSliders() {
  document.querySelectorAll('.multicolumn-slider .splide').forEach(function(slider) {
    if (slider.classList.contains('is-initialized')) return;

    whenSplideReady(function () {
      if (slider.classList.contains('is-initialized')) return;
      slider.classList.add('is-initialized');

      var splide = new Splide(slider, {
        type: slider.dataset.type || 'slide',
        perPage: parseInt(slider.dataset.slidesDesktop) || 3,
        perMove: parseInt(slider.dataset.perMoveDesktop) || 1,
        autoplay: slider.dataset.autoplay === "true",
        interval: (parseFloat(slider.dataset.autoplaySpeed) || 5) * 1000,
        arrows: slider.dataset.arrows !== "hidden",
        pagination: slider.dataset.dots !== "hidden",
        autoHeight: true,
        breakpoints: {
          749: {
            perPage: parseInt(slider.dataset.slidesMobile) || 1,
            arrows: slider.dataset.mobileArrows !== "hidden",
            pagination: slider.dataset.mobileDots !== "hidden",
          }
        }
      }).mount();

      slider.querySelectorAll('img, video').forEach(function(el) {
        var isVideo = el.tagName === 'VIDEO';
        var alreadyLoaded = isVideo ? (el.readyState >= 2) : (el.complete);
        if (alreadyLoaded) {
          splide.refresh();
        } else {
          el.addEventListener(isVideo ? 'loadeddata' : 'load', function () {
            splide.refresh();
          }, { once: true });
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initMulticolumnSliders);
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMulticolumnSliders);
}

  } catch(e) { console.error(e); }
})();
})();
